<p-popover
  #popover
  [styleClass]="styleClass()"
  (onHide)="onHide.emit(true)"
  (onShow)="onShow.emit(true)"
  [appendTo]="appendTo()"
  [style]="overlayPanelStyles()"
  [dt]="dt()">
  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
</p-popover>
